// Stripe API exponents are not Intl/ICU currency display defaults.
// https://docs.stripe.com/currencies#zero-decimal
const ZERO_DECIMAL_CURRENCIES = new Set(['BIF', 'CLP', 'DJF', 'GNF', 'JPY', 'KMF', 'KRW', 'MGA', 'PYG', 'RWF', 'UGX', 'VND', 'VUV', 'XAF', 'XOF', 'XPF']);
const THREE_DECIMAL_CURRENCIES = new Set(['BHD', 'JOD', 'KWD', 'OMR', 'TND']);

// Preserve the exact safe integer through BigInt; never divide money as a float.
export function formatMinor(amount, currency) {
  if (!Number.isSafeInteger(amount) || typeof currency !== 'string' || !/^[a-z]{3}$/i.test(currency)) return 'Unavailable';
  try {
    const code = currency.toUpperCase();
    // Stripe retains two-decimal API amounts for ISK/UGX despite whole-unit display.
    // HUF/TWD remain two-decimal API amounts, including payouts.
    // https://docs.stripe.com/currencies#special-cases
    const legacyWholeUnits = code === 'ISK' || code === 'UGX';
    const apiDigits = legacyWholeUnits ? 2 : ZERO_DECIMAL_CURRENCIES.has(code) ? 0 : THREE_DECIMAL_CURRENCIES.has(code) ? 3 : 2;
    const displayDigits = legacyWholeUnits ? 0 : apiDigits;
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency', currency: code, currencyDisplay: 'code',
      minimumFractionDigits: displayDigits, maximumFractionDigits: displayDigits,
    });
    const units = BigInt(amount);
    const absolute = units < 0n ? -units : units;
    const scale = 10n ** BigInt(apiDigits);
    if (legacyWholeUnits && absolute % scale !== 0n) return 'Unavailable';
    const fraction = (absolute % scale).toString().padStart(displayDigits, '0');
    const text = formatter.formatToParts(absolute / scale).map(part => part.type === 'fraction' ? fraction : part.value).join('');
    return `${units < 0n ? '-' : ''}${text}`;
  } catch { return 'Unavailable'; }
}
